/*!
 * eq v0.10.20 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var EQ_BLOCK = 'u-eq';
var EQ_DEFAULT_PREFIX = "".concat(EQ_BLOCK, "--");
var EQ_DEFAULT_BREAKPOINTS = ['gte260', 'lt260', 'gte390', 'lt390', 'gte520', 'lt520', 'gte780', 'lt780', 'gte1040', 'lt1040'];
var EQ_BREAKPOINT_REGEX = /(.+?)([0-9]+)/i;
var COMPARATORS = {
  '>': function _(a, b) {
    return a > b;
  },
  '>=': function _(a, b) {
    return a >= b;
  },
  '<': function _(a, b) {
    return a < b;
  },
  '<=': function _(a, b) {
    return a <= b;
  },
  '=': function _(a, b) {
    return a == b;
  } // eslint-disable-line eqeqeq

};
var COMPARATOR_ALIASES = Object.assign(Object.keys(COMPARATORS).reduce(function (acc, x) {
  acc[x] = x;
  return acc;
}, {}), {
  gt: '>',
  gte: '>=',
  lt: '<',
  lte: '<=',
  is: '='
});

var defaultComparator = function defaultComparator() {
  return false;
};

var resolveComparator = function resolveComparator(comparator) {
  return COMPARATORS[COMPARATOR_ALIASES[comparator]] || defaultComparator;
};
var fit = function fit(current, _ref) {
  var comparator = _ref.comparator,
      value = _ref.value;
  return resolveComparator(comparator)(current, value);
};
var fitMap = function fitMap(current, comparators) {
  return comparators.filter(function (x) {
    return fit(current, x);
  });
};
var diff = function diff(from, to) {
  return from.filter(function (f) {
    return !to.includes(f);
  });
};
var toggleClasses = function toggleClasses(classes, el) {
  var apply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return classes.forEach(function (className) {
    return el.classList.toggle(className, apply);
  });
};
function parseBreakpoint(breakpoint) {
  var _breakpoint$match = breakpoint.match(EQ_BREAKPOINT_REGEX),
      _breakpoint$match2 = _slicedToArray(_breakpoint$match, 3),
      key = _breakpoint$match2[0],
      comparator = _breakpoint$match2[1],
      value = _breakpoint$match2[2];

  return {
    key: key,
    comparator: comparator,
    value: parseFloat(value)
  };
}
var EqObserver =
/*#__PURE__*/
function () {
  function EqObserver() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$block = _ref2.block,
        block = _ref2$block === void 0 ? EQ_BLOCK : _ref2$block,
        _ref2$prefix = _ref2.prefix,
        prefix = _ref2$prefix === void 0 ? EQ_DEFAULT_PREFIX : _ref2$prefix,
        _ref2$breakpoints = _ref2.breakpoints,
        breakpoints = _ref2$breakpoints === void 0 ? EQ_DEFAULT_BREAKPOINTS : _ref2$breakpoints;

    _classCallCheck(this, EqObserver);

    this.block = block;
    this.prefix = prefix;
    this.handleChange = this.handleChange.bind(this);
    this.getClassName = this.getClassName.bind(this);
    this.breakpoints = [];
    this.els = [];
    this.setTriggers(this.breakpoints);
    this.observer = new ResizeObserver(this.handleChange);
    this.update({
      breakpoints: breakpoints
    });
  }

  _createClass(EqObserver, [{
    key: "setTriggers",
    value: function setTriggers(breakpoints) {
      this.triggers = breakpoints.map(parseBreakpoint);
    }
  }, {
    key: "handleChange",
    value: function handleChange(entries) {
      var _this = this;

      entries.forEach(function (entry) {
        var width = entry.contentRect.width;

        _this.apply(_this.triggers, fitMap(width, _this.triggers), entry.target);
      });
    }
  }, {
    key: "getClassName",
    value: function getClassName(_ref3) {
      var key = _ref3.key;
      return "".concat(this.prefix).concat(key);
    }
  }, {
    key: "apply",
    value: function apply(base, applicable, el) {
      var setClasses = applicable.map(this.getClassName);
      var removeClasses = diff(base.map(this.getClassName), setClasses);
      toggleClasses(removeClasses, el, false);
      toggleClasses(setClasses, el, true);
    }
  }, {
    key: "update",
    value: function update() {
      var _this2 = this;

      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$breakpoints = _ref4.breakpoints,
          breakpoints = _ref4$breakpoints === void 0 ? this.breakpoints : _ref4$breakpoints;

      var oldTriggers = this.triggers;
      this.breakpoints = breakpoints;
      this.setTriggers(this.breakpoints);
      this.els.forEach(function (el) {
        _this2.apply(oldTriggers, fitMap(el.getBoundingClientRect().width, _this2.triggers), el);
      });
    }
  }, {
    key: "bind",
    value: function bind(el) {
      this.els.push(el);
      this.observer.observe(el);
      this.update();
      return this;
    }
  }, {
    key: "unbind",
    value: function unbind(el) {
      var index = this.els.indexOf(el);

      if (index) {
        this.els.splice(index, 1);
      }

      this.observer.unobserve(el);
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.observer.disconnect();
      this.els = [];
      return this;
    }
  }]);

  return EqObserver;
}();

export { COMPARATORS, COMPARATOR_ALIASES, EQ_BLOCK, EQ_BREAKPOINT_REGEX, EQ_DEFAULT_BREAKPOINTS, EQ_DEFAULT_PREFIX, EqObserver, diff, fit, fitMap, parseBreakpoint, resolveComparator, toggleClasses };
